import styled from 'styled-components';

export const FlexColumn = styled.div`
	display: flex;
	flex-direction: column;
	flex: ${(props) => props.flex || ''};
	width: ${(props) => props.width || '100%'};
`;
